// @flow
import * as React from 'react';
// $FlowFixMe
import { components } from 'react-select3';
import { usePrevious } from 'react-use';
import styled, { injectGlobal } from 'styled-components';
// $FlowFixMe
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Dropdown from '../dropdown_select';
import { colors } from '../../constants';
import CheckboxTree from '../checkbox_tree';

type Option = {
  value: number | string,
  label: string,
  children?: Array<Option>,
};

type Props = {
  pluralLabel: string,
  options: Array<Option>,
  value: Array<Option>,
  onChange: (Array<Option>) => void,
  onMenuClose?: () => void,
};

const MultiSelect = (props: Props) => {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);
  const prevMenuIsOpen = usePrevious(menuIsOpen);
  const { pluralLabel, options, onMenuClose } = props;

  React.useEffect(() => {
    if (prevMenuIsOpen === true && menuIsOpen === false) {
      onMenuClose && onMenuClose();
    }
  }, [prevMenuIsOpen, menuIsOpen, onMenuClose]);

  const value = props.value || [];

  const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;

    if (Array.isArray(values)) {
      if (values.length > 1) {
        values = `${values.length} ${pluralLabel} selected`;
      }
    }

    return (
      <components.ValueContainer {...props}>
        {values.length === 1 || menuIsOpen ? (
          children
        ) : (
          <>
            {values}
            {input}
          </>
        )}
      </components.ValueContainer>
    );
  };
  ValueContainer.displayName = ValueContainer;

  const findOptions = (ids) => {
    const set = new Set(ids);

    return (accumulator, option) => {
      if (!set.has(option.value) && Array.isArray(option.children)) {
        return accumulator.concat(option.children.reduce(findOptions(set), []));
      }

      if (set.has(option.value)) {
        return accumulator.concat(option);
      }

      return accumulator;
    };
  };

  const MenuList = () => {
    return (
      <StyledMenuList>
        <CheckboxTree
          expandAll
          nodes={options}
          checked={value.map((v) => v.value)}
          onChange={(topLayerIds) =>
            props.onChange(options.reduce(findOptions(topLayerIds), []))
          }
        />
      </StyledMenuList>
    );
  };
  MenuList.displayName = MenuList;

  return (
    <ClickAwayListener onClickAway={() => setMenuIsOpen(false)}>
      <StyledDropdown
        {...props}
        isMulti
        isClearable
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        onChange={(selectedOption, triggeredAction) => {
          switch (triggeredAction.action) {
            case 'clear':
              props.onChange([]);
              break;
            case 'remove-value':
              const { removedValue } = triggeredAction;
              props.onChange(
                value.filter((option) => option.value !== removedValue.value)
              );
              break;
            default:
              break;
          }
        }}
        components={{
          ValueContainer: ValueContainer,
          MenuList,
        }}
      />
    </ClickAwayListener>
  );
};

MultiSelect.displayName = 'MultiSelect';
export default MultiSelect;

// $FlowFixMe
const StyledDropdown = styled(Dropdown)`
  .sl-dropdown__menu {
    border: 1px solid ${colors.lightGrey};
    box-shadow: 3px 3px 8px ${colors.lightGrey};
    border-radius: 3px;
    top: 98%;
  }

  .sl-dropdown__control {
    max-height: 55px;
    overflow: auto;
  }
`;

const StyledMenuList = styled.div`
  margin: 18px;
`;

injectGlobal`
  .react-checkbox-tree {
    input[type="checkbox"] {
      margin: 6px 8px;
      vertical-align: baseline;
    }

    button.rct-collapse-btn {
      margin: 3px auto;
    }

    button .rct-icon.rct-icon-expand-open,
    button .rct-icon.rct-icon-expand-close {
      vertical-align: middle;
    }
  }
`;
